import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ToastMessageService} from "../../services/toast-message.service";
import {ActivatedRoute, Params} from "@angular/router";
import {VerifyVerificationService} from "../service/verify-verification.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'fb-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss', '../login/login.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

	public authSubscription: Subscription = {} as Subscription;
	public showPasswordForm: boolean = false;
	public token: string = '';
	public passwordType: 'password' | 'text' = 'password';
	public confirmPasswordType: 'password' | 'text' = 'password';
	public emailFormControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.email
	]);
	public passwordFormControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.minLength(8),
		Validators.maxLength(38)
	]);

	public confirmPasswordFormControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.minLength(8),
		Validators.maxLength(38)
	]);


	public forgotPasswordFormGroup: FormGroup = new FormGroup({
		email: this.emailFormControl
	});

	public resetPasswordFormGroup: FormGroup = new FormGroup({
		password: this.passwordFormControl,
		confirmPassword: this.confirmPasswordFormControl
	})

	constructor(
		private _toast: ToastMessageService,
		private _activatedRouter: ActivatedRoute,
		private _verifyAPI: VerifyVerificationService,
	) {
	}
	public onEmailSend(): void {
		if(this.forgotPasswordFormGroup.valid) {
			this._verifyAPI.sendPasswordResetEmail(this.emailFormControl.value);
		}
		else {
			this.emailFormControl.markAsDirty();
		}
	}
	public ngOnInit(): void {
		this.authSubscription = this._activatedRouter.params.subscribe((params: Params) => {
			this.token = params['forgotPasswordToken'];
			this.showPasswordForm = !!this.token;
		});
	}

	public onResetPassword(): void {
		if(this.resetPasswordFormGroup.valid && (this.passwordFormControl.value === this.confirmPasswordFormControl.value)) {
			this._verifyAPI.resetPassword(
				{
					token: this.token,
					password: this.passwordFormControl.value
				},
				false
			);
		}
		else {
			this.passwordFormControl.markAsDirty();
			this.confirmPasswordFormControl.markAsDirty();
		}
	}

	public ngOnDestroy(): void {
		if(this.authSubscription) {
			this.authSubscription.unsubscribe();
		}
	}
}
